import { KYMW1704Model } from '../kymw1704.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';



/**
 * 画像個別登録管理_サンプル発注先取得するサービス
 *
 * @export GetSupplierNameService
 * @class GetSupplierNameService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetSupplierNameService extends PlessJsonResponderSub<any> {

  private sampleOrderingCode: string;

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1704Model}
   * @memberof GetSupplierNameService
   */
  private model: KYMW1704Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetSupplierNameService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSupplierNameService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        SupplierCode: this.sampleOrderingCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetSupplierNameService
   */
  execute(model: any, sampleOrderingCode: string, successFunc: Function): void {
    this.model = <KYMW1704Model> model;
    this.sampleOrderingCode = sampleOrderingCode;
    this.successFunc = successFunc;
    this.send('KYMW0C00GetSupplierName', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSupplierNameService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
